import { render, staticRenderFns } from "./vip-idcard-login.vue?vue&type=template&id=6d6378db&scoped=true&"
import script from "./vip-idcard-login.vue?vue&type=script&lang=js&"
export * from "./vip-idcard-login.vue?vue&type=script&lang=js&"
import style0 from "./vip-idcard-login.vue?vue&type=style&index=0&id=6d6378db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6378db",
  null
  
)

export default component.exports